import { IUserDataToken } from 'utils/types';
import { IGetUsers, IUser } from 'views/backoffice/users/types';
import { useLazyQuery, useQuery } from '@apollo/client';
import { QUERY_GET_USERS } from 'graphql/queries/users';
import { useEffect, useState } from 'react';
import { QUERY_ME } from 'graphql/mutations/auth';

const useUser = () => {
    const { data: curUserData } = useQuery(QUERY_ME);
    const userFromToken: IUserDataToken | null = curUserData?.me ? JSON.parse(curUserData.me) : null;
    const [currentUser, setCurrentUser] = useState<IUser | null>(null);

    const [getUsers, { data: userData }] = useLazyQuery<IGetUsers>(QUERY_GET_USERS, {});
    useEffect(() => {
        if (userFromToken?.userId) {
            getUsers({
                variables: {
                    data: {
                        filter: {
                            id: +userFromToken.userId
                        },
                        pagination: {
                            pageSize: 1,
                            pageNumber: 1
                        }
                    }
                }
            });
        }
    }, [userFromToken?.userId, getUsers]);

    useEffect(() => {
        if (!userData?.getSaasUsers?.length) return;
        setCurrentUser(userData?.getSaasUsers?.find(({ id }) => +id === Number(userFromToken?.userId)) as IUser);
    }, [userData?.getSaasUsers, userFromToken?.userId]);

    return {
        userFromToken,
        currentUser
    };
};

export default useUser;
